import styled from "@emotion/styled";
export const StyledSettingUpCallLoadingScreen = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  
  .loading-screen-image {
    max-width: 200px;
    max-height: 140px;
    mix-blend-mode: multiply;
  }
    
  .loading-screen-text {
    font-size: 1.5rem;
    font-weight: 500;
    margin-top: 32px;
    text-align: center;
  }
`;
